import { render } from "./UploadXmlFiles.vue?vue&type=template&id=0118429e&scoped=true"
import script from "./UploadXmlFiles.vue?vue&type=script&lang=js"
export * from "./UploadXmlFiles.vue?vue&type=script&lang=js"

import "./UploadXmlFiles.vue?vue&type=style&index=0&id=0118429e&scoped=true&lang=css"

import exportComponent from "/srv/guestwaiterreportingfront/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0118429e"]])

export default __exports__